<template>
	<div role="tabcard" class="tab-pane" id="add-crew-member">
		<div class="card card-default">
		    <div class="card-header">
				<div class="fw-600 float-left font-size-large">Add team member or subcontractor</div>
			</div>

		    <div class="card-body">
		        <!-- Success Message -->
		        <div class="alert alert-success" v-if="form.successful">
		            Great, an invitation was sent to <strong>{{ emailSent }}</strong>!
		        </div>

		        <div class="alert alert-danger" v-if="error">
		            {{ errorMessage }}
		        </div>

		        <div class="row">
		        	<div class="col-md-12">
			        	<div class="alert alert-light">
			        		<div class="row mb-2 mt-2">
			        			<div class="col-md-12">
			        				<h5><i class="fas fa-user-tag mr-2 text-success"></i>Which role is right?</h5>
			        			</div>
			        		</div>
			        		<div class="row">
					        	<div class="col-md-6 border-right">
					        		<p>
					        			<span class="fw-600">Administrators</span> have unrestricted access to Site Command, and can:
					        			<ul class="mt-2">
					        				<li>create projects</li>
					        				<li>create work orders</li>
					        				<li>create change orders</li>
					        				<li>create material selections</li>
					        				<li>invite team members</li>
					        			</ul>
					        		</p>
					        	</div>
					        	<div class="col-md-6">
					        		<p><span class="fw-600">Team members & subcontractors</span> can only see the projects, work orders, change orders, and material selections that they are assigned to.</p>
					        		<p>They <span class="fw-600">do not have</span> access to pricing for projects, change orders, or material selections.
					        		</p>
					        	</div>
				        	</div>
			        	</div>
		        	</div>
		        </div>

		        <form role="form">
		        	<!-- Name Address -->
		            <div class="form-group row">
		                <label class="col-md-3 col-form-label text-md-right">Name</label>

		                <div class="col-md-6">
		                    <input type="text" class="form-control" name="name" v-model="form.name" :class="{'is-invalid': form.errors.has('name')}">
		                    <span class="invalid-feedback" v-show="form.errors.has('name')">
		                        @{{ form.errors.get('name') }}
		                    </span>
		                </div>
		            </div>

		            <!-- E-Mail Address -->
		            <div class="form-group row">
		                <label class="col-md-3 col-form-label text-md-right">Email</label>

		                <div class="col-md-6">
		                    <input type="email" class="form-control" name="email" v-model="form.email" :class="{'is-invalid': form.errors.has('email')}">
		                    <span class="invalid-feedback" v-show="form.errors.has('email')">
		                        @{{ form.errors.get('email') }}
		                    </span>
		                </div>
		            </div>

		            <!-- Role -->
		            <div class="form-group row">
		                <label class="col-md-3 col-form-label text-md-right">Role</label>

		                <div class="col-md-6">
		                    <select class="form-control" v-model="form.role" :class="{'is-invalid': form.errors.has('role')}" >
		                        <option v-for="(role, index) in roles" :value="role.value" v-bind:selected="index === 0">{{ role.text }}</option>
		                    	}
		                    </select>
		                    <span class="invalid-feedback" v-show="form.errors.has('role')">
		                        {{ form.errors.get('role') }}
		                    </span>
		                </div>
		            </div>

		            <!-- Send Invitation Button -->
		            <div class="form-group row mb-0">
		                <div class="offset-md-3 col-md-6">
		                    <button type="submit" class="btn btn-primary"
		                            @click.prevent="sendInvitation"
		                            :disabled="form.busy">


		                        <!-- 
		                        :key here is workaround for removing fontawesome icons with v-if 
		                        https://github.com/FortAwesome/vue-fontawesome/issues/30
		                    	-->
		                        <span :key='123' v-if="form.busy">
		                            <i class="fa fa-btn fa-spinner fa-spin"></i> Sending
		                        </span>

		                        <span v-else>
		                            Send invitation
		                        </span>
		                    </button>
		                </div>
		            </div>
		        </form>
		    </div>
		</div>
	</div>
</template>

<script>
    export default {
        created: function() {
        	this.getCrewRoles();
        },

        mounted: function() {

        },

        data: function() {
            return {
            	form: new SparkForm({
            		name: '',
            	    email: '',
            	    role: 'employee',
            	}),
            	roles: [],
            	error: false,
            	errorMessage: '',
            	successMessage: '',
            	emailSent: '',
            };
        },

        computed: {
            
        },

        methods: {
           getCrewRoles: function() {
               axios.get('/api/crew/roles')
                   .then(response => {
                       this.loading = false;
                       this.roles = response.data;
                   });
           },

           sendInvitation: function() {
           		Spark.post('/api/crew', this.form)
           		    .then(response => {
           		    	this.error = false;
           		    	this.loading = false;
           		        this.form.email = '';
           		        this.form.role = 'employee';
           		        this.successMessage = response.message;
           		        this.emailSent = response.email;
           		    })
           		    .catch(error => {
           		    	this.loading = false;
           		    	this.error = true;
           		    	this.errorMessage = error.message;
           		    });
           },
        }
    }
</script>